<template>
  <div :class="{ 'single-image-upload-wrap': true }">
    <div
      class="single-image-wrap"
      :style="{ width: imageWidth + 'px' }"
      v-show="fileUrl && showStyle == 'image'"
    >
      <el-icon @click="clearFile" :size="16" color="#fff" class="image-close"
        ><close
      /></el-icon>
      <el-image
        :style="{
          height: imageHeight + 'px',
          width: imageWidth + 'px',
        }"
        class="image-item"
        :fit="'contain'"
        :src="fileUrl"
        :preview-src-list="[fileUrl]"
       referrerpolicy="no-referrer"></el-image>
    </div>
    <div class="single-file-wrap" v-show="fileUrl && showStyle == 'file'">
      <el-tooltip class="item" :content="fileUrl">
        <el-link class="button" target="_BLANK" :href="fileUrl">
          点击下载
        </el-link>
      </el-tooltip>
      <el-icon
        @click="clearFile"
        :size="16"
        style="margin-left: 10px; vertical-align: middle"
        color="#fff"
        class="image-close"
      >
        <close />
      </el-icon>
    </div>
    <el-upload
      :ref="(el:any) => (uploadRef = el)"
      v-show="!disabled && !fileUrl"
      v-loading="uploading"
      :element-loading-text="`上传中(${percent * 100})...`"
      :http-request="httpRequest"
      :before-upload="beforeUpload"
      :on-success="onFileUploadSuccess"
      :multiple="false"
      :show-file-list="false"
      :limit="1"
    >
      <el-icon
        :style="{
          height: imageHeight + 'px',
          width: imageWidth + 'px',
          lineHeight: imageHeight + 'px',
        }"
        class="upload-btn"
      >
        <plus />
      </el-icon>
    </el-upload>
  </div>
</template>
<script lang="ts">
import { Plus, Close } from "@element-plus/icons-vue";
import { defineComponent, watch, reactive, ref, onMounted } from "vue";
import type { ExtractPropTypes, SetupContext, PropType, Ref } from "vue";
import { cloneDeep } from "lodash-es";

import request from "@user-center/utils/request";
import { getOssToken } from "@user-center/api/common";
import _Upload from "element-plus/es/components/upload";
import { ElMessage } from "element-plus";
import OSS from "ali-oss";
const SingleImageUploadProps = {
  modelValue: {
    type: String,
    default: "",
  },
  showStyle: {
    type: String,
    default: "image",
  },
  imageWidth: {
    type: Number,
    default: 100,
  },
  imageHeight: {
    type: Number,
    default: 100,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  bucket: {
    type: String,
    default: "mps-1302460406",
  } /* 必须 */,
  region: {
    type: String,
    default: "ap-guangzhou",
  } /* 存储桶所在地域，必须字段 */,
  protocol: {
    type: String,
    default: "http:",
  },
  cosInitConf: {
    type: Object,
    default: () => ({}),
  },
  authUrl: {
    type: String,
    default: window.location.origin + "/getUploadToken",
  },
};
export type SingleImageUploadType = {
  uploadRef: Ref<typeof _Upload | null>;
  fileUrl: Ref<string>;
  uploading: Ref<boolean>;
  percent: Ref<number>;
  clearFile(): void;
  onFileUploadSuccess(response: any): void;
  httpRequest(conf: any): void;
  beforeUpload(file: File): void;
  disabled: boolean;
};
export type SingleImageUploadPropsType = ExtractPropTypes<
  typeof SingleImageUploadProps
>;
export default defineComponent({
  name: "SingleImageUpload",
  components: { Plus, Close },
  props: SingleImageUploadProps,

  setup(
    props: SingleImageUploadPropsType,
    ctx: SetupContext
  ): SingleImageUploadType {
    let fileUrl: Ref<string> = ref(props.modelValue);
    let uploading: Ref<boolean> = ref(false);
    let percent: Ref<number> = ref(0);
    let uploadData = {
      key: "",
      name: "",
    };
    let cosObject: OSS;

    const uploadRef: Ref<typeof _Upload | null> = ref(null);
    watch(
      () => props.modelValue,
      (newVal) => {
        if (!newVal) {
          clearFile();
        } else {
          fileUrl.value = newVal;
        }
      }
    );
    onMounted(() => {});
    function beforeUpload(file: File): void {
      console.log(file, "beforeUpload");
      // var observable = qiniu.upload(file, key, token, putExtra, config)

      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (props.showStyle == "image") {
        if (!isPNG && !isJPEG && !isJPG) {
          ElMessage.error("上传图片只能是 jpg、png、jpeg 格式!");
          return;
        }
        if (!isLt2M) {
          ElMessage.error("上传图片大小不能超过 2MB!");
          return;
        }
      }

      uploadData.key = `upload_pic_${new Date().getTime()}_${file.name}`;
      uploadData.name = `upload_pic_${new Date().getTime()}_${file.name}`;
    }
    function httpRequest(opt: any): Promise<any> {
      console.log("uploading");
      uploading.value = true;
      return new Promise((resolve, reject) => {
        getOssToken()
          .then((sign: any) => {
            cosObject = new OSS({
              accessKeyId: sign.accessKeyId, // 后台的临时签名ID
              accessKeySecret: sign.accessKeySecret, // 后台的临时签名密钥
              stsToken: sign.securityToken,

              endpoint: "oss-cn-guangzhou.aliyuncs.com/", // 上传后的域名
              bucket: "sztjyshop", // OSS仓库名
            });

            const curTime = new Date();
            const year = curTime.getFullYear();
            const month = curTime.getMonth() + 1;
            const day = curTime.getDate();
            // 生成日期文件夹 自定义，可根据自身业务 区分文件夹。每个 ‘ / ’ 即是一级目录
            const dir =
              "imgs/" +
              year +
              "/" +
              (month < 10 ? "0" + month : month) +
              "-" +
              (day < 10 ? "0" + day : day) +
              "/";

            cosObject
              .put(dir + uploadData.name, opt.file)
              .then((res) => {
                uploading.value = false;
                resolve(res);
              })
              .catch((err) => {
                reject(err);
              });
          })
          .catch((err: Error) => {
            uploading.value = false;
            if (err) {
              reject(err);
            }
          });
      });
    }
    function clearFile(): void {
      uploadRef.value && uploadRef.value.clearFiles();
      fileUrl.value = "";
      ctx.emit("update:modelValue", fileUrl.value);
    }

    function onFileUploadSuccess(response: any): void {
      if (response.url && typeof response.url == "string") {
        fileUrl.value = response.url;
        ctx.emit("update:modelValue", fileUrl.value);
      } else {
        clearFile();
      }
    }
    return {
      uploading,
      percent,
      beforeUpload,
      httpRequest,
      uploadRef,
      fileUrl,
      clearFile,
      onFileUploadSuccess,
      disabled: props.disabled,
    };
  },
});
</script>
<style lang="scss" scoped>
.single-image-upload-wrap {
  .image-close {
    background: #f00;
    border-radius: 100%;

    cursor: pointer;
  }
  .single-image-wrap {
    position: relative;
    line-height: 1;
    .image-close {
      position: absolute;
      right: -8px;
      top: -6px;

      z-index: 2;
    }
    .image-item {
      width: 145px;
      height: 145px;
      border: 1px solid #eee;
      border-radius: 5px;
    }
  }
  .upload-btn {
    border: 1px dashed #ccc;
    border-radius: 5px;
    color: #ccc;
    font-size: 24px;
  }
}
</style>
